import React from 'react';

import { StagingAreaContainer } from '@atlassian/smart-creation';
import { type ConversationAssistantConfig } from '@atlassian/conversation-assistant';

import type { RouteMatch } from '@confluence/route';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { fg } from '@confluence/feature-gating';
import { SmartCreatePromptLoader } from '@confluence/smart-create/entry-points/SmartCreatePrompt';

export const SmartCreateRoute = (routeMatch: RouteMatch) => {
	if (!fg('confluence_ai_create_menu_item')) {
		return;
	}

	const sessionId = routeMatch?.query?.sessionId;

	const config = (): ConversationAssistantConfig => {
		const cloudId = Array.isArray(routeMatch?.query?.cloudId)
			? routeMatch?.query?.cloudId[0] || ''
			: routeMatch?.query?.cloudId || '';
		const product = Array.isArray(routeMatch?.query?.product)
			? routeMatch?.query?.product[0] || ''
			: routeMatch?.query?.product || '';
		return {
			assistanceServiceConfig: {
				headers: {
					'X-Cloudid': cloudId,
				},
				baseUrl: '/gateway/api/assist',
			},
			displaySubmitFlag: true,
			siteId: cloudId,
			product: product,
		};
	};

	if (sessionId && fg('confluence_ai_staging_area_routing')) {
		return (
			<StagingAreaContainer
				spaceKey={(routeMatch?.query?.spaceKey as string) || ''}
				config={config()}
			/>
		);
	}

	return <SmartCreatePromptLoader spaceKey={(routeMatch?.query?.spaceKey as string) || ''} />;
};

SmartCreateRoute.NAVIGATION_PARAMS = (routeMatch: RouteMatch) => {
	const spaceKey = routeMatch?.query?.spaceKey ?? '';
	const cloudId = routeMatch?.query?.cloudId ?? '';
	const product = routeMatch?.query?.product ?? '';
	return {
		Screen: {
			screenEvent: {
				name: 'smartCreatePromptScreen',
			},
			pageState: { spaceKey, routeName: routeMatch.name, cloudId, product },
		},
		MainLayout: {
			spaceKey,
			navView: CONTAINER_HOME_ID,
		},
	};
};
